import { EcpServices } from '../../ecp-locator';
import { AppointmentType } from '../../../../../graphql';

export const getAppointmentType = (service?: EcpServices): AppointmentType => {
  switch (service) {
    case EcpServices.aec:
      return AppointmentType.aec;
    case EcpServices.cv:
      return AppointmentType.controlVisit;
    default:
      return AppointmentType.default;
  }
};
